import { useMemo } from 'react'
import { useOrder } from './useOrderState'
import { useLocalSearchParams } from 'expo-router'

const useActiveOrderItem = () => {
  const order = useOrder()

  // Prefer orderItemId from params over activeItemId
  const { orderItemId } = useLocalSearchParams<{
    orderItemId: string
  }>()
  return useMemo(() => {
    const current = orderItemId || order.activeItemId
    const index = order.items.findIndex((item) => item.id === current)

    if (index === -1) {
      return {
        activeItem: null,
        activeItemId: null,
      }
    }

    return {
      activeItem: order.items[index],
      index,
    }
  }, [order.items, order.activeItemId, orderItemId])
}

export const useActiveGlassesIndex = () => {
  const activeOrder = useActiveOrderItem()
  const index = activeOrder.index != null ? activeOrder.index + 1 : 1
  const frame = activeOrder.activeItem?.frame
  const frameId = frame?.default_code || frame?.id || undefined

  return { index, frame, frameId }
}

export default useActiveOrderItem
